import { render, staticRenderFns } from "./viewNotice.vue?vue&type=template&id=682dd33a&scoped=true&"
import script from "./viewNotice.vue?vue&type=script&lang=js&"
export * from "./viewNotice.vue?vue&type=script&lang=js&"
import style0 from "./viewNotice.vue?vue&type=style&index=0&id=682dd33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682dd33a",
  null
  
)

export default component.exports